import api from './api';
import {
    db,
    serverTimestamp,
} from '../config/firebase';

function softCheck(params) {
    return new Promise((resolve, reject) => {
        const consentsTypes = [
            'hmrc_income_check',
            'experian_soft_credit_check',
        ];
        const updateCustomer = () => (
            new Promise((resolvePromise, rejectPromise) => {
                const doc = db
                    .collection('customers')
                    .doc(params.applicantId)
                    .collection('consents');
                const promisesArr = consentsTypes.map(consentFor => (
                    new Promise((resolveItem, rejectItem) => {
                        doc
                            .add({
                                consentFor,
                                date: serverTimestamp(),
                            })
                            .then((docRef) => {
                                resolveItem({
                                    consentFor,
                                    id: docRef.id,
                                });
                            })
                            .catch((error) => {
                                rejectItem(error.message);
                            });
                    })
                ));
                Promise
                    .all(promisesArr)
                    .then((data) => {
                        resolvePromise(data);
                    })
                    .catch((error) => {
                        rejectPromise(error);
                    });
            })
        );
        updateCustomer()
            .then((consents) => {
                const {
                    application,
                } = params;
                const applicationParams = {
                    applicationType: application.applicationType,
                    applicants: application.applicants,
                    applicantsIncome: application.applicantsIncome,
                    mortgageType: application.mortgageType,
                    property: application.property,
                    requestedTimeSpan: application.requestedTimeSpan,
                };
                const applicantParams = {
                    ...params.applicant,
                    idVerification: {},
                    incomeCheck: {
                        uuid: 'kuku',
                        decision: 'allow',
                        result: {},
                        data: {},
                    },
                };
                switch (application.mortgageType) {
                case 'remortgage_current_balance':
                    applicationParams.remortgageAmount = applicationParams.requestedLoanAmount;
                    break;
                case 'remortgage_and_borrow_more':
                    applicationParams.additionalAmount = applicationParams.requestedLoanAmount;
                    break;
                default:
                    applicationParams.requestedLoanAmount = applicationParams.requestedLoanAmount;
                }
                api([
                    {
                        method: 'incomeCheck',
                        params: {
                            consents: [
                                {
                                    consentId: consents[0].id,
                                    consentFor: consents[0].consentFor,
                                    applicant: applicantParams,
                                    state: 'yes',
                                },
                            ],
                            income: application.applicantsIncome[0],
                            applicant: applicantParams,
                        },
                    },
                    {
                        method: 'personalSoftCheck',
                        params: {
                            consents: [
                                {
                                    consentId: consents[1].id,
                                    consentFor: consents[1].consentFor,
                                    applicant: applicantParams,
                                    state: 'yes',
                                },
                            ],
                            application: applicationParams,
                            applicant: applicantParams,
                        },
                    },
                ])
                    .then((data) => {
                        if (data.error) {
                            reject(data.error);
                        } else {
                            const resolvedData = {
                                decision: (
                                    data[0].result.decision === 'allow'
                                    && data[1].result.decision === 'allow'
                                )
                                    ? 'allow'
                                    : 'deny',
                                maxLendAmount: data[1].result.maxLendAmount || {},
                            };
                            const collection = db.collection('applications');
                            collection
                                .doc(params.applicationId)
                                .update({
                                    softCheck: {
                                        resolvedData,
                                        incomeCheck: data[0].result,
                                        personalSoftCheck: data[1].result,
                                    },
                                    lastUpdate: serverTimestamp(),
                                    'formStepper.activeStep': 5,
                                })
                                .then(() => {
                                    resolve(resolvedData);
                                })
                                .catch((error) => {
                                    reject(error.message);
                                });
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
    });
}

export default softCheck;



// WEBPACK FOOTER //
// ./src/service/softCheck.js